// Liquid Filter Bag Products Data
export const liquidFilterBagProducts = {
  'liquid-filter-bag': {
    id: 'liquid-filter-bag',
    title: 'Liquid Filter Bag (LFB) Series',
    name: 'Liquid Filter Bag',
    category: 'Liquid Filter Bag',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/c62c06b038c8fe5f0b2b77ca7b90027d.jpg',
    shortDescription: 'Versatile liquid filter bags available in various materials, sizes, and precisions for a wide range of industrial applications.',
    description: 'The Liquid Filter Bag (LFB) series offers a comprehensive solution for liquid filtration, providing a wide selection of materials, filtration precisions, and configurations to meet diverse industrial requirements. These bags are designed for high performance, efficiency, and durability.',
    longDescription: 'Our Liquid Filter Bag series are designed for optimal filtration performance. They come in various media materials like Polypropylene (PP), Polyester (PE), Nylon Monofilament (NMO), PTFE, and Activated Carbon Fiber (ACF). With filtration precision ranging from 0.5 to 800µm and options for single or multi-layer construction, these filter bags can be tailored to specific applications. The choice of ring materials and connection types (heat-welded or sewn) adds to their versatility, making them suitable for everything from general water filtration to aggressive chemical processing.',
    features: [
      'Wide range of media materials: PP, PE, NMO, PTFE, ACF',
      'High filtration precision from 0.5µm to 800µm',
      'Available in single, double, or triplicate layers for enhanced efficiency',
      'Multiple bag sizes and ring materials (PP, PE, SS, Galvanized Steel)',
      'Heat-welded or sewn connection types',
      'Efficient multi-layer option provides 2-3 times higher removal rate than single layer felt bags'
    ],
    applications: [
      'General water treatment',
      'Chemical processing (acids, alkalis, solvents)',
      'Food and beverage industry',
      'Petrochemicals and oil industry',
      'Paints, inks, and coatings',
      'Pharmaceuticals'
    ],
    specifications: {
      'Filter Media': 'PE / PP / PTFE, Nylon, Activated Carbon Fiber (ACF)',
      'Filtration Precision (PE/PP/PTFE)': '0.5, 1, 3, 5, 10, 25, 50, 100, 200µm',
      'Filtration Precision (Nylon)': '25, 50, 80, 100, 125, 150, 200, 250, 300, 400, 600, 800µm (20-600 Mesh)',
      'Bag Sizes': '1-Dia.Φ7”, L17”; 2-Dia.Φ7”, L32”; 3-Dia.Φ4”, L9”; 4-Dia.Φ4”, L15”; 5-Dia.Φ6”, L22”',
      'Ring Material': 'PP–Polypropylene, PE–Polyethylene, SS–Stainless steel, ZS–Galvanized steel, PR–Polyester rope',
      'Connection Type': 'H–Heat-welded, X–Sewn',
      'Bag Layers': '01L–Single layer, 02L–Double layers, 03L–Triplicate layers',
      'Efficient Multi-Layer': 'Removal Efficiency is Higher Than 90% 2-3 Times Removal Rate Of Common Single Layer Felt Bag'
    },
    technicalData: {
      'Chemical Compatibility': [
        { Media: 'PE', 'Temperature Resistant °C': '150-170', 'Strong Acid': '-', 'Week Acid': '●', 'Strong Alkali': '-', 'Weak Alkali': '-', Olein: '●', Aromatic: '●', 'Alcohol Ether': '●', 'Organic Solvent': '●', Water: '●' },
        { Media: 'PP', 'Temperature Resistant °C': '90-110', 'Strong Acid': '●', 'Week Acid': '●', 'Strong Alkali': '●', 'Weak Alkali': '●', Olein: '●', Aromatic: '●', 'Alcohol Ether': '-', 'Organic Solvent': '●', Water: '●' },
        { Media: 'Nylon', 'Temperature Resistant °C': '150-170', 'Strong Acid': '-', 'Week Acid': '-', 'Strong Alkali': '●', 'Weak Alkali': '●', Olein: '●', Aromatic: '●', 'Alcohol Ether': '●', 'Organic Solvent': '●', Water: '●' },
        { Media: 'PTFE', 'Temperature Resistant °C': '250-300', 'Strong Acid': '●', 'Week Acid': '●', 'Strong Alkali': '●', 'Weak Alkali': '●', Olein: '●', Aromatic: '●', 'Alcohol Ether': '●', 'Organic Solvent': '●', Water: '●' },
      ],
      'Ordering Guide Options': [
        { 'Media Material': 'PP-Polypropylene', 'Filtration Precision (μm)': '0.5', 'Bag Size': '1: Dia.Φ7”, L17”', 'Ring Material': 'PP-Polypropylene', 'Connection Type': 'H-Heat-welded', 'Bag Layers': '01L-Single layer' },
        { 'Media Material': 'PE-Polyester', 'Filtration Precision (μm)': '1', 'Bag Size': '2: Dia.Φ7”, L32”', 'Ring Material': 'PE-Polyethylene', 'Connection Type': 'X-Sewn', 'Bag Layers': '02L-Double layers' },
        { 'Media Material': 'NMO-Nylon Monofilament', 'Filtration Precision (μm)': '5', 'Bag Size': '3: Dia.Φ4”, L9”', 'Ring Material': 'SS-Stainless steel', 'Connection Type': '', 'Bag Layers': '03L-Triplicate layers' },
        { 'Media Material': 'PTFE-Polytetrafluoroethylene', 'Filtration Precision (μm)': '10', 'Bag Size': '4: Dia.Φ4”, L15”', 'Ring Material': 'ZS-Galvanized steel', 'Connection Type': '', 'Bag Layers': '' },
        { 'Media Material': 'ACF-Activated carbon fiber', 'Filtration Precision (μm)': '25', 'Bag Size': '5: Dia.Φ6”, L22”', 'Ring Material': 'PR-Polyester rope', 'Connection Type': '', 'Bag Layers': '' },
        { 'Media Material': '', 'Filtration Precision (μm)': '50', 'Bag Size': '', 'Ring Material': '', 'Connection Type': '', 'Bag Layers': '' },
        { 'Media Material': '', 'Filtration Precision (μm)': '75', 'Bag Size': '', 'Ring Material': '', 'Connection Type': '', 'Bag Layers': '' },
        { 'Media Material': '', 'Filtration Precision (μm)': '100', 'Bag Size': '', 'Ring Material': '', 'Connection Type': '', 'Bag Layers': '' },
        { 'Media Material': '', 'Filtration Precision (μm)': '...', 'Bag Size': '', 'Ring Material': '', 'Connection Type': '', 'Bag Layers': '' }
      ],
      'Available Models': [
        { 
          'Model': 'LFB-PP-50-2-PP-H-01L',
          'Series': 'LFB',
          'Media Material': 'PP',
          'Filtration Precision (µm)': '50',
          'Bag Size': '2',
          'Ring Material': 'PP',
          'Connection Type': 'H',
          'Bag Layers': '01L'
        },
        { 
          'Model': 'LFB-PE-1-2-PE-X-02L',
          'Series': 'LFB',
          'Media Material': 'PE',
          'Filtration Precision (µm)': '1',
          'Bag Size': '2',
          'Ring Material': 'PE',
          'Connection Type': 'X',
          'Bag Layers': '02L'
        },
        { 
          'Model': 'LFB-NMO-25-3-SS-X-03L',
          'Series': 'LFB',
          'Media Material': 'NMO',
          'Filtration Precision (µm)': '25',
          'Bag Size': '3',
          'Ring Material': 'SS',
          'Connection Type': 'X',
          'Bag Layers': '03L'
        }
      ]
    }
  }
};

export const liquidFilterBagProductsList = [
  {
    id: 'liquid-filter-bag',
    name: 'Liquid Filter Bag',
    category: 'Liquid Filter Bag',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/c62c06b038c8fe5f0b2b77ca7b90027d.jpg',
    shortDescription: 'Versatile liquid filter bags available in various materials, sizes, and precisions for a wide range of industrial applications.',
    description: 'A comprehensive solution for liquid filtration, providing a wide selection of materials like PP, PE, NMO, and PTFE, with filtration precisions from 0.5 to 800μm.',
    features: [
      'Wide range of media materials (PP, PE, NMO, PTFE, etc.)',
      'High filtration precision from 0.5µm to 800µm',
      'Multiple sizes, layers, and ring materials available'
    ],
    applications: [
      'General water treatment',
      'Chemical processing',
      'Food and beverage industry'
    ]
  }
];

export default liquidFilterBagProducts;